<template>
     <div class="site-view">
        
        <Header :title="Title"/>
        <section class="page-section have-your-say">
            <div class="container">
                <div class="row">
                    <div class="col m12 l12">
                        <div class="text-wrap center-align">
                            <div class="mb4">
                                <p class="hr-title mb4"><hr class="hr-purple"><b>Have Your Say</b></p>
                                <h1 class="light">Your Feedback</h1>
                                <!-- <p class="resize">This is the public consultation and the objective is to invite members of the public to comment on the proposals.<br/> These comments will assist the Department for Infrastructure in the identification of the preferred routes for BRT2. </p> -->
                            </div>
                        </div>
                        
                    </div>                    
                </div>
            </div>
            

           
            <div v-if="!isMobile" class="container ">
                <div class="row haveYourSayContainerRow">
                    <div class="col m12 l6">
                        <div class="text-wrap center-align ">
                            <div class="mb4 ">
                                <h1 class="hasYourSayDebugText">Desktop Q'naire</h1>
                                <h2 style="margin-top:4rem;color: #00203F;font-family: Roboto;">The consultation is now closed.</h2>
                                <!-- <iframe v-bind:style="desktopFrameStyles" class="haveYourSayIframe" src="/map/entity/gnzMtAZnfEwWjsUW3IHX/addentity/feedback" width="100%" height="400px"></iframe> -->
                                <!-- <iframe v-bind:style="desktopFrameStyles" class="haveYourSayIframe"  src="map/entity/gnzMtAZnfEwWjsUW3IHX/addentity/feedback" height="400px" width="100%"></iframe> -->
                            </div>
                        </div>                
                    </div>                    
                    <div class="col m12 l6">
                        <div class="text-wrap center-align hasYourSayContainer">
                            <div class="mb4 hasYourSayContainer">
                                <h1 class="hasYourSayDebugText">Desktop Map</h1>
                                <img ref="imageDesktop" width="100%" src="@/assets/images/Belfast/Maps/completeMap.png"/>
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>

            <div v-if="isMobile" class="container ">
                <div class="row haveYourSayContainerRow">
                    <div class="col m12 l6 ">
                        <div class="text-wrap center-align ">
                            <div class="mb4 ">
                                <h1 class="hasYourSayDebugText">Mobile Q'naire</h1>
                                <h2 style="margin-top:4rem;color: #00203F;font-family: Roboto;">The consultation is now closed.</h2>
                                <!-- <iframe v-bind:style="mobileFrameStyles" class="haveYourSayIframe" ref="" width="100%" src="/map/entity/gnzMtAZnfEwWjsUW3IHX/addentity/feedback"></iframe> -->
                            </div>
                        </div>                
                    </div>                                   
                </div>
            </div>

            <div v-if="isMobile" class="container ">
                <div class="row haveYourSayContainerRow">
                    <div class="col m12 l6">
                        <div class="text-wrap center-align">
                            <div class="mb4 ">
                                <h1 class="hasYourSayDebugText">Mobile Map</h1>
                                <img ref="imageMobile" width="100%" src="@/assets/images/Belfast/Maps/completeMap.png"/>
                            </div>
                        </div>                
                    </div>                                   
                </div>
            </div>

            

        </section>
        <!-- <section class="full-screen-banner">
            <img class="full-screen-banner hide-on-small-and-down" src="@/assets/images/Belfast/all/purple-banner.png" alt="" />
         </section>   -->
        <OneColumnFooter/>
        <Footer />
    </div>
</template>

<script>
import OneColumnFooter from "@/components/belfast/OneColumnFooter";
import Map from "@/components/EntityEdit";
import MapView from "@/views/Clusterview";
import MapViewOnly from "@/views/MapViewOnly";
import Footer from "@/components/belfast/Footer";
import Header from "@/components/belfast/HeroHeaderOtherPages";
export default {
  name: "have-your-say",
   components: {
    Header,
    Footer,
    OneColumnFooter,
    Map,
    MapView,
    MapViewOnly
    
  },
  mounted(){
      console.log("mounted()");
      window.setTimeout(() => {
        console.log("nextTick");
        // Will be executed when the DOM is ready
        if(window.innerWidth < 1024) {
            this.isMobile = true
        } else {
            this.isMobile = false; 
        }
        if(this.isMobile){
            var mobileHeight = this.$refs.imageMobile.clientHeight + "px";
            console.log("mobileHeight");
            console.log(mobileHeight);
            this.mobileFrameStyles = { height: mobileHeight };
        }else{
            var desktopHeight = this.$refs.imageDesktop.clientHeight + "px";
            console.log("desktopHeight");
            console.log(desktopHeight);
            this.desktopFrameStyles =  { height: desktopHeight };
        }
    }, 500);
  },
  data() {
    return {
        isMobile: false,
        hasRunOnce: false,
        Title:"Have Your Say",  
        mobileFrameStyles: { height: "800px" },  
        desktopFrameStyles: { height: "800px" },
    }
  }
};
</script>
<style lang="scss">
.haveYourSayContainerRow {
    background: white;
    border-radius: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
}
.hasYourSayDebugText {
    color: navy;
    font-style: italic;
    display: none;
}
.haveYourSayIframe{
    border: 1px solid white;
}
</style>

